import { createSlice } from '@reduxjs/toolkit'
import {
    getAllUserRewardPointACTION,
} from '../actions/rewardPoint.Action'

const INITIAL_STATE = {
    rewardPointDetail: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        }
    },
};

const rewardPointReducer = createSlice({
    name: 'RewardPoint',
    initialState: INITIAL_STATE,
    reducers: {
        ResetRewardPointState(state, action) {
            state.rewardPointDetail = INITIAL_STATE.rewardPointDetail;
        }
    },
    extraReducers: (builder) => {
        //------------------------------- getAllUserRewardPointACTION start -------------------------
        builder.addCase(getAllUserRewardPointACTION.fulfilled, (state, action) => {
            state.rewardPointDetail.data = action.payload.data
            state.rewardPointDetail.apiMsg.status = action.meta.requestStatus;
            state.rewardPointDetail.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getAllUserRewardPointACTION.pending, (state, action) => {
            state.rewardPointDetail.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllUserRewardPointACTION.rejected, (state, action) => {
            state.rewardPointDetail.apiMsg.message = action.error.message;
            state.rewardPointDetail.apiMsg.status = action.meta.requestStatus;
        });
    }
})

export const { ResetRewardPointState } = rewardPointReducer.actions;
export default rewardPointReducer.reducer;